/**
 * 3DS-specific transaction status.
 */
export var ThreeDsStatus;
(function (ThreeDsStatus) {
    /** Unknown status. */
    ThreeDsStatus["Unknown"] = "U";
    /** Successful transaction. */
    ThreeDsStatus["Success"] = "Y";
    /** Failed transaction. */
    ThreeDsStatus["Failure"] = "N";
})(ThreeDsStatus || (ThreeDsStatus = {}));
//# sourceMappingURL=ThreeDsStatus.js.map